export default __webpack_public_path__ + "static/media/ph2.51649412.webp";